import { createTheme, type ThemeOptions } from "@mui/material";
import themeJson from "./theme.json";

const baseTheme = createTheme(themeJson as ThemeOptions);
const muiTheme = createTheme(baseTheme, {
  components: {
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 'bold',
          color: '#000000',
          position: 'relative',
          zIndex: 1,
          '&.Mui-selected': {
            color: '#000000',
          },
          '&:hover': {
            color: '#00f49c',
            borderRadius: 4,
          },'&.Mui-selected:hover': {
            color: '#ffffff',
          },

        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 20,
          padding: '8px 24px',
        },
        containedPrimary: {
          backgroundColor: '#00f49c',
          color: '#000000',
          '&:hover': {
            backgroundColor: '#00d889',
          },
          '&:disabled': {
            backgroundColor: '#e0e0e0',
            color: '#999',
          },
        },
        containedSuccess: {
          backgroundColor: '#4caf50',
          color: '#ffffff',
          '&:hover': {
            backgroundColor: '#388e3c',
          },
        },
        containedError: {
          backgroundColor: '#C62828',
          color: '#ffffff',
          '&:hover': {
            backgroundColor: '#B71C1C',
          },
        },
        outlinedPrimary: {
          borderColor: '#000000',
          color: '#000000',
          '&:hover': {
            borderColor: '#000000',
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
          },
        },
        outlinedSuccess: {
          borderColor: '#4caf50',
          color: '#4caf50',
          '&:hover': {
            borderColor: '#4caf50',
            backgroundColor: 'rgba(76, 175, 80, 0.04)',
          },
        },
        outlinedError: {
          borderColor: '#C62828',
          color: '#C62828',
          '&:hover': {
            borderColor: '#C62828',
            backgroundColor: 'rgba(198, 40, 40, 0.04)',
          },
        },
        text: {
          color: '#000000',
          '&:hover': {
            backgroundColor: 'rgba(0, 244, 156, 0.04)',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#00f49c',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#00f49c',
            },
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#00f49c',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#00f49c',
          },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 12,
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          fontSize: '1.25rem',
          color: '#000000',
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          borderColor: '#e0e0e0',
          color: '#666',
          '&:hover': {
            backgroundColor: 'rgba(0, 244, 156, 0.04)',
          }
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
          '&:hover': {
            boxShadow: '0 4px 16px rgba(0, 0, 0, 0.15)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        },
        elevation1: {
          boxShadow: '0 1px 4px rgba(0, 0, 0, 0.1)',
        },
        elevation2: {
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        },
        elevation3: {
          boxShadow: '0 4px 16px rgba(0, 0, 0, 0.15)',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          fontWeight: 500,
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          paddingLeft: 16,
          paddingRight: 16,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          color: '#000000',
          boxShadow: '0 1px 4px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-head': {
            backgroundColor: '#f8f9fa',
            fontWeight: 600,
            color: '#000000',
          },
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: 'rgba(0, 244, 156, 0.04)',
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: 'rgba(0, 244, 156, 0.04)',
          },
        },
      },
    },
  },
});
export default muiTheme;
